<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;500;600;700&display=swap");

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .container {
    margin: 16px;
    padding: 0;
    border-radius: 12px;
  }
  
  .card-header {
    padding: 20px 16px;
  }
  
  .card-body {
    padding: 20px 16px;
  }
  
  .main {
    padding: 16px 0;
  }
  
  .steps {
    padding: 16px 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .steps li {
    margin: 0 4px;
    min-width: 60px;
  }
  
  .steps li:before {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  
  .steps li:after {
    font-size: 10px;
    max-width: 80px;
  }
  
  .input-text {
    margin-bottom: 16px;
  }
  
  .buttons {
    flex-direction: column;
    gap: 12px;
  }
  
  .buttons button {
    width: 100%;
    max-width: none;
  }
  
  .custom-tooltip {
    max-width: 90vw;
    min-width: 200px;
    right: -50px;
  }
  
  .progress-indicator {
    font-size: 11px;
    padding: 4px 10px;
  }
}

@media (max-width: 480px) {
  .top-div h4 {
    font-size: 22px;
  }
  
  .input-group {
    flex-direction: column;
  }
  
  .tooltip-button {
    border-radius: 12px !important;
    border-left: 2px solid #e5e7eb;
    width: 100%;
    margin-top: 8px;
  }
}

.d-none {
  display: none !important;
}

/* Enhanced Container Styling */
.container {
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 25px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  overflow: hidden;
  position: relative;
}

.container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #10b981, #f59e0b, #ef4444);
  background-size: 200% 100%;
  animation: gradient-shift 3s ease-in-out infinite;
}

@keyframes gradient-shift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  padding: 24px 32px;
  border-radius: 16px 16px 0 0;
  border-bottom: none;
  position: relative;
  overflow: hidden;
}

.card-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%);
  pointer-events: none;
}

.card-header h4 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 32px;
  background: #fafbfc;
  border-radius: 0 0 16px 16px;
}

.main {
  padding: 24px 0;
  display: none;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.main_signin {
  padding: 24px 0;
  display: none;
}

.active {
  display: block !important;
  opacity: 1;
  transform: translateX(0);
}

.slideDown {
  animation: slideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Micro-animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Apply animations to form elements */
.main.active .input-text {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.main.active .input-text:nth-child(1) { animation-delay: 0.1s; }
.main.active .input-text:nth-child(2) { animation-delay: 0.2s; }
.main.active .input-text:nth-child(3) { animation-delay: 0.3s; }
.main.active .input-text:nth-child(4) { animation-delay: 0.4s; }
.main.active .input-text:nth-child(5) { animation-delay: 0.5s; }

.main.active .buttons {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) both;
  animation-delay: 0.6s;
}

/* Floating labels animation */
.floating-label {
  position: relative;
}

.floating-label label {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  background: white;
  padding: 0 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  color: #9ca3af;
  font-size: 16px;
}

.floating-label input:focus + label,
.floating-label input:not(:placeholder-shown) + label {
  top: 0;
  font-size: 12px;
  color: #3b82f6;
  font-weight: 600;
}

.top-div {
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
}

.top-div h4 {
  color: #1f2937;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.top-div .mb-5 {
  color: #6b7280;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px !important;
}

.steps {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px 10px;
}

.steps .step .circle {
  height: 40px;
  width: 40px;
  background-color: #ccc;
  border-radius: 50%;
}
.steps .step .line {
  width: 22%;
}
.top-div img {
  width: 60px;
  margin-bottom: 10px;
}
.top-div h2 {
  color: #484a4c;
}
.top-div p {
  color: #585e61;
  font-size: 14px;
  font-weight: 700;
}
/* Enhanced Input Styling */
.input-text {
  margin-bottom: 24px;
  margin-top: 16px;
}

.input-text label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  letter-spacing: 0.025em;
}

.input-group {
  position: relative;
  display: flex;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 2px solid #e5e7eb;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.input-group:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
}

.input-group:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 6px rgba(0, 0, 0, 0.07);
  transform: translateY(-2px);
}

/* Enhanced focus states */
.input-group {
  position: relative;
  overflow: visible;
}

.input-group::before {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 14px;
  padding: 2px;
  background: linear-gradient(45deg, #3b82f6, #8b5cf6, #ec4899);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-group:focus-within::before {
  opacity: 1;
}

/* Input field interactions */
input[type="text"]:focus,
input[type="password"]:focus,
input[type="email"]:focus,
input[type="phone"]:focus,
input[type="number"]:focus,
input[type="date"]:focus,
select:focus,
textarea:focus {
  background: linear-gradient(to bottom, #ffffff, #f8fafc);
}

/* Ripple effect on click */
.input-group {
  position: relative;
  overflow: hidden;
}

.input-group::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.input-group:active::after {
  width: 300px;
  height: 300px;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="phone"],
input[type="number"],
input[type="date"],
select {
  flex: 1;
  height: 48px;
  border: none;
  background: transparent;
  outline: 0;
  font-size: 16px;
  padding: 12px 16px;
  color: #1f2937;
  transition: all 0.2s ease;
}

input[type="text"]::placeholder,
input[type="password"]::placeholder,
input[type="email"]::placeholder,
input[type="phone"]::placeholder,
input[type="number"]::placeholder,
input[type="date"]::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

input[type="text"]:focus,
input[type="password"]:focus,
input[type="email"]:focus,
input[type="phone"]:focus,
input[type="number"]:focus,
input[type="date"]:focus,
select:focus {
  background: #f8fafc;
}

select {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%236b7280' viewBox='0 0 16 16'><path d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;
}

.input-group-append,
.tooltip-container {
  position: relative;
}

.input-group-prepend .input-group-text,
.input-group-append .input-group-text {
  background: #f9fafb;
  border: none;
  color: #6b7280;
  font-weight: 500;
  padding: 12px 16px;
  font-size: 14px;
}

textarea {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  height: 120px;
  width: 100%;
  outline: 0;
  padding: 16px;
  font-size: 16px;
  color: #1f2937;
  resize: vertical;
  font-family: inherit;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

textarea:hover {
  border-color: #d1d5db;
}

textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: #f8fafc;
}

.input-text select option:nth-child(1) {
  display: none !important;
}

.custom-select {
  border-radius: 0 !important;
  border: none !important;
  background: transparent !important;
}
/* Enhanced Button Styling */
.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
  padding: 0 8px;
}

.final_button {
  margin-top: 40px;
}

.buttons button {
  height: 52px;
  min-width: 140px;
  outline: 0;
  border: 2px solid transparent;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  letter-spacing: 0.025em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  max-width: 200px;
}

.buttons button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.buttons button:hover::before {
  left: 100%;
}

.buttons button.bg-success {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.3);
}

.buttons button.bg-success:hover {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
}

.buttons button.bg-success:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.3);
}

.buttons button.bg-outline-secondary {
  background: white;
  color: #6b7280;
  border-color: #d1d5db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.buttons button.bg-outline-secondary:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.buttons button.bg-outline-secondary:active {
  transform: translateY(-1px);
  background: #f3f4f6;
}

.buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #e5e7eb !important;
}

.buttons button:disabled::before {
  display: none;
}

.buttons button i {
  font-size: 14px;
}

.next_button, .previous_button {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 14px;
}
/* Enhanced Validation Styling */
.warning, .invalid {
  border-color: #ef4444 !important;
  background-color: #fef2f2 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97);
}

.invalid .input-group {
  border-color: #ef4444 !important;
  background-color: #fef2f2 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }
  20%, 40%, 60%, 80% { transform: translateX(2px); }
}

/* Success State */
.valid .input-group {
  border-color: #10b981 !important;
  background-color: #f0fdf4 !important;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
}

.field-success {
  border-color: #10b981 !important;
  background-color: #f0fdf4 !important;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
}

/* Required Field Indicator */
.required::after {
  content: ' *';
  color: #ef4444;
  font-weight: bold;
}

/* Error Message Styling */
.error-message {
  color: #ef4444;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.error-message::before {
  content: '⚠';
  font-size: 14px;
}

/* Warning Alert */
.w-100.text-center.mt-4.pt-4.mb-4.pb-4 {
  background: linear-gradient(135deg, #fef3cd, #fde68a);
  border-radius: 12px;
  padding: 24px;
  border: 2px solid #f59e0b;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.2);
}

.w-100.text-center.mt-4.pt-4.mb-4.pb-4 h3 {
  color: #92400e;
  font-weight: 600;
  margin: 0;
}

.form_color {
  width: 50px;
  height: 35px;
}

/* Mark input boxes that gets an error on validation: */
.invalid {
  background-color: #ffdddd;
}

.check_box {
  text-align: center;
}
.check_box p {
  font-size: 13px;
  font-weight: 700;
}

.sign_in {
  text-align: center;
  margin: 20px 0;
}
.sign_button {
  margin-top: 70px;
}

/* Enhanced Success Animation */
.checkmark {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: block;
  stroke-width: 3;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 40px auto;
  box-shadow: inset 0px 0px 0px #10b981;
  animation: fill 0.4s ease-in-out 0.4s forwards,
    scale 0.3s ease-in-out 0.9s both;
  position: relative;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 3;
  stroke-miterlimit: 10;
  stroke: #10b981;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

/* Success page animation */
.success-content {
  animation: bounceIn 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) both;
  animation-delay: 0.5s;
}

/* Loading states */
.skeleton-loader {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 8px;
  height: 48px;
  margin-bottom: 16px;
}

@keyframes loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Loading overlay */
.loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f4f6;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Enhanced Tooltip and Info Button Styling */
.tooltip-button {
  position: relative !important;
  border: 2px solid #e5e7eb;
  border-left: none;
  border-radius: 0 12px 12px 0 !important;
  background: linear-gradient(135deg, #f8fafc, #f1f5f9);
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #64748b;
  min-width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

/* CSS-only tooltip fallback */
.tooltip-button:hover + .custom-tooltip {
  opacity: 1 !important;
  visibility: visible !important;
  transform: translateY(0) scale(1) !important;
}

.tooltip-button:hover {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border-color: #2563eb;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.tooltip-button:active {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.4);
}

.tooltip-button i {
  font-size: 16px;
  transition: transform 0.2s ease;
}

.tooltip-button:hover i {
  transform: scale(1.1);
}

/* Enhanced Custom Tooltip Styling */
.custom-tooltip {
  position: absolute;
  bottom: calc(100% + 20px);
  right: 0;
  background: #1e293b;
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  max-width: 350px;
  min-width: 250px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px) scale(0.95);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  z-index: 9999;
  pointer-events: none;
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.15),
    0 8px 16px rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(255, 255, 255, 0.05);
  line-height: 1.5;
  backdrop-filter: blur(20px);
}

.custom-tooltip p {
  margin: 0;
  white-space: normal;
  word-wrap: break-word;
}

.custom-tooltip.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

.custom-tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #1e293b;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* Alternative positioning for better visibility */
.tooltip-container:hover .custom-tooltip,
.tooltip-container .custom-tooltip.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
}

/* Ensure tooltips appear above other elements */
.tooltip-container {
  z-index: 10;
}

.tooltip-container .custom-tooltip {
  z-index: 9999;
}

/* Info button variations */
.btn-outline-info.border-0 {
  border: 2px solid #e5e7eb !important;
  background: white;
  color: #6b7280;
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.3s ease;
}

.btn-outline-info.border-0:hover {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6 !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

.steps {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  margin: 20px 0;
  position: relative;
}

.steps::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 2px;
  z-index: 1;
  transform: translateY(-50%);
}

/* Progress bar */
.steps::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10%;
  height: 4px;
  background: linear-gradient(90deg, #10b981, #3b82f6);
  border-radius: 2px;
  z-index: 2;
  transform: translateY(-50%);
  transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  width: var(--progress-width, 0%);
}

/* Progress percentage indicator */
.progress-indicator {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: #1f2937;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
}

.steps:hover .progress-indicator {
  opacity: 1;
}

.steps li {
  list-style: none;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
  flex: 1;
  max-width: 200px;
  margin: 0 10px;
}

.steps li:hover {
  transform: translateY(-2px);
}

.steps li:hover:before {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3);
}

.steps li:before {
  content: counter(css-counter);
  counter-increment: css-counter;
  
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
  color: #6b7280;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  border: 3px solid #e5e7eb;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 8px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.steps li:after {
  content: attr(data-step-name);
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  text-align: center;
  transition: all 0.3s ease;
  opacity: 0.8;
  max-width: 120px;
  word-wrap: break-word;
  line-height: 1.3;
}

.steps li.li-completed:before {
  background: linear-gradient(135deg, #10b981, #047857);
  color: white;
  border-color: #059669;
  content: "✓";
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.steps li.li-completed:after {
  color: #059669;
  font-weight: 500;
}

.steps li.li-future:before {
  background: linear-gradient(135deg, #f9fafb, #f3f4f6);
  color: #9ca3af;
  border-color: #e5e7eb;
}

.steps li.li-future:after {
  color: #9ca3af;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
  }
  50% {
    box-shadow: 0 6px 24px rgba(59, 130, 246, 0.6);
  }
}

.steps {
  counter-reset: css-counter 0;
}
</style>

<template>
  <div
    v-if="pages.length > 0"
    :style="{ 
        '--customization_custom_background': customization.custom_background , 
        '--customization_custom_color': customization.custom_color,
        '--customization_font_family': customization.font_family,
        '--customization_label_font_family': customization.label_font_family,
        '--customization_label_color': customization.label_color,
        '--customization_button_border_color': customization.button_border_color,
        '--customization_button_border': customization.button_border,
      }"
    class="container my-5 p-3 card shadow-md"
    style="border: 1px solid rgb(40, 167, 69, 0.4)"
  >
    <app-overlay-loader v-if="preloader" />
    <div class="card-header" :style="{ backgroundColor: customization.custom_background, color: customization.custom_color }">
      <h4 class="text-uppercase font-weight-bold">
        {{ formname }}
      </h4>
    </div>

    <div class="card-body">
      <form action="">
        <ul class="steps" :style="{ '--progress-width': progressWidth }">
          <div class="progress-indicator">{{ Math.round(progressPercentage) }}% Complete</div>
          <li
            v-for="(page, index) in pages"
            :key="index"
            :class="{
              'li-active': formnumber === index,
              'li-completed': formnumber > index,
              'li-future': formnumber < index
            }"
            :data-step-name="replaceFieldKeysWithValues(page.name)"
            @click="showTab(index)"
          >
          </li>
        </ul>

        <!-- One "tab" for each step in the form: -->
        <div class="main" v-for="(page, index) in pages" :key="page.id" :class="formnumber === index ? 'active' : ''">
          <div class="top-div">
            <h4>{{ replaceFieldKeysWithValues(page.name) }}</h4>
            <div class="mb-5" v-html="replaceFieldKeysWithValues(page.step_description)"></div>
            
            <div v-if="page.custom_values.length<=0" class="w-100 text-center mt-4 pt-4 mb-4 pb-4">
              <h3 class="text-center text-warning mt-4 pt-4 mb-4 pb-4">
                {{ emptyStateConfig.message }}
              </h3>
              <div v-if="emptyStateConfig.purchase_url" class="mt-2">
                <a :href="emptyStateConfig.purchase_url" target="_blank" rel="noopener" class="btn" :style="{ backgroundColor: customization.button_background, color: customization.button_color, borderColor: customization.button_border_color, borderWidth: customization.button_border + 'px' }">
                  {{ emptyStateConfig.link_text }}
                </a>
              </div>
            </div>
            
            <div v-else v-for="(custom_value, val_index) in Object.values(page.custom_values)" :key="custom_value.id" class="input-text">
              
              <!--select-->
              <div v-if="'select' === custom_value_type(custom_value.custom_field_type_id)">
                <label for="" class="m-0 d-block">{{ custom_value.field_name }}</label>
                <div class="input-group">
                  <select class="custom-select" :class="{ required: custom_value.required }"
                    :name="custom_value.field_name" :ref="custom_value.field_name"
                    v-model="field_values[index][val_index].value" @change="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" oninput='this.classList.remove("invalid")'>
                    <option disabled :value="''" selected="selected">
                      Please select an option
                    </option>
                    <option v-for="element in custom_value.choices.split(';')" :key="element" :value="element">
                      {{ element }}
                    </option>
                  </select>
                  <div class="input-group-append tooltip-container">
                    <button type="button" class="btn btn-outline-info border-0 tooltip-button" 
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <div :class="['custom-tooltip', { 'show': isTooltipActive(custom_value.field_key) }]">
                      <p v-html="custom_value.description || 'No description available'"></p>
                    </div>
                  </div>
                </div>
              </div>

              <!--multi-select-->
              <div v-if="'multi-select' === custom_value_type(custom_value.custom_field_type_id)">
                <label for="" class="m-0 d-block">{{ custom_value.field_name }}</label>
                <div class="input-group">
                  <multiselect :name="custom_value.field_name" :ref="custom_value.field_name" :multiple="true"
                    :clear-on-select="false" :preserve-search="true" placeholder="Please select option"
                    v-model="field_values[index][val_index].value" @input="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" :preselect-first="false" :close-on-select="false" :options="custom_value.choices.split(';')">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length > 0 && !isOpen">{{ values.length }} options selected</span>
                    </template>
                  </multiselect>
                  <div class="input-group-append tooltip-container">
                    <button type="button" class="btn btn-outline-info border-0 tooltip-button" 
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <div :class="['custom-tooltip', { 'show': isTooltipActive(custom_value.field_key) }]">
                      <p v-html="custom_value.description || 'No description available'"></p>
                    </div>
                  </div>
                </div>
              </div>

              <!--text-->
              <div v-if="['text', 'number', 'password', 'date'].includes(custom_value_type(custom_value.custom_field_type_id))">
                <label for="" class="m-0">{{ custom_value.field_name }}</label>
                <div class="input-group">
                  <span class="input-group-prepend" v-if="custom_value.prefix">
                    <span class="input-group-text">{{ custom_value.prefix }}</span>
                  </span>
                  
                  <input v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                    :type="custom_value_type(custom_value.custom_field_type_id)"
                    class="form-control"
                    :class="{ required: custom_value.required }"
                    :placeholder="custom_value.field_name"
                    :readonly="true"
                    :ref="custom_value.field_name"
                    :name="custom_value.field_name"
                    :value="getFieldOperationValue(
                      operations_values[custom_value.field_key].operand1,
                      operations_values[custom_value.field_key].operand2,
                      operations_values[custom_value.field_key].operator,
                      operations_values[custom_value.field_key].type
                    )"
                    @change="setCustomValue(
                      getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      ),
                      custom_value
                    )"
                    oninput='this.classList.remove("invalid")' />

                  <input v-else
                    :type="custom_value_type(custom_value.custom_field_type_id)"
                    class="form-control"
                    :class="{ required: custom_value.required }"
                    :placeholder="custom_value.field_name"
                    :ref="custom_value.field_name"
                    :name="custom_value.field_name"
                    v-model="field_values[index][val_index].value"
                    @change="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )"
                    oninput='this.classList.remove("invalid")' />
                  
                  <span class="input-group-append" v-if="custom_value.suffix">
                    <span class="input-group-text">{{ custom_value.suffix }}</span>
                  </span>

                  <div class="input-group-append tooltip-container">
                    <button type="button" class="btn btn-outline-info border-0 tooltip-button" 
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <div :class="['custom-tooltip', { 'show': isTooltipActive(custom_value.field_key) }]">
                      <p v-html="custom_value.description || 'No description available'"></p>
                    </div>
                  </div>
                </div>
              </div>

              <!--color picker-->
              <div v-if="'Color picker' === custom_value_type(custom_value.custom_field_type_id)">
                <label class="m-0 d-block">{{ custom_value.field_name }}</label>
                <div class="input-group">
                  <div v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)">
                    <input type="color" class="form_color" disabled :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name"
                      @change="setCustomValue(
                        getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        ),
                        custom_value
                      )" :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )" />
                    <input type="text" disabled class="form_color ml-2" :readonly="true" 
                      :ref="custom_value.field_name" :name="custom_value.field_name"
                      @change="setCustomValue(
                        getFieldOperationValue(
                          operations_values[custom_value.field_key].operand1,
                          operations_values[custom_value.field_key].operand2,
                          operations_values[custom_value.field_key].operator,
                          operations_values[custom_value.field_key].type
                        ),
                        custom_value
                      )" :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )" />
                  </div>

                  <div v-else>
                    <input type="color" class="form_color" v-model="field_values[index][val_index].value" @input="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )" />
                    <input type="text" class="form_color ml-2" v-model="field_values[index][val_index].value" @input="setCustomValue(
                        field_values[index][val_index].value,
                        custom_value
                      )" />
                  </div>
                  
                  <div class="input-group-append tooltip-container">
                    <button type="button" class="btn btn-outline-info border-0 tooltip-button" 
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <div :class="['custom-tooltip', { 'show': isTooltipActive(custom_value.field_key) }]">
                      <p v-html="custom_value.description || 'No description available'"></p>
                    </div>
                  </div>
                </div>
              </div>

              <!--file-->
              <div v-if="'File' === custom_value_type(custom_value.custom_field_type_id)">
                <File :custom_value="custom_value" />
              </div>

              <!--textarea-->
              <div v-if="'textarea' == custom_value_type(custom_value.custom_field_type_id)">
                <label for="" class="m-0">{{ custom_value.field_name }}</label>
                <div class="input-group">
                  <app-input 
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                    custom-config
                    type="textarea"
                    class="shadow-sm w-100 " 
                    :removeClass="true"
                    inputClass="textarea_height"
                    :required="true"
                    :id="'textarea-id' + index + val_index"
                    :label="custom_value.field_name"
                    :class="{ required: custom_value.required }"
                    :name="custom_value.field_name" 
                    :ref="custom_value.field_name"
                    @input="setCustomValue(
                      getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      ),
                      custom_value
                    )" :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )"
                    oninput='this.classList.remove("invalid")'
                    :placeholder="custom_value.field_name" 
                  />

                  <app-input v-else
                    custom-config
                    type="textarea"
                    class="shadow-sm w-100 " 
                    :removeClass="true"
                    inputClass="textarea_height"
                    :required="true"
                    :id="'textarea-id' + index + val_index"
                    :key="'text-editor-id' + index + val_index"
                    :label="custom_value.field_name"
                    :class="{ required: custom_value.required }"
                    :name="custom_value.field_name" 
                    :ref="custom_value.field_name"
                    v-model="field_values[index][val_index].value"
                    @input="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" 
                    oninput='this.classList.remove("invalid")'
                    :placeholder="custom_value.field_name" 
                  />

                  <div class="input-group-append tooltip-container">
                    <button type="button" class="btn btn-outline-info border-0 tooltip-button" 
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <div :class="['custom-tooltip', { 'show': isTooltipActive(custom_value.field_key) }]">
                      <p v-html="custom_value.description || 'No description available'"></p>
                    </div>
                  </div>
                </div>
              </div>

              <!--text editor-->
              <div v-if="'text-editor' == custom_value_type(custom_value.custom_field_type_id)">
                <label for="" class="m-0">{{ custom_value.field_name }}</label>
                <div class="input-group">
                  <app-input 
                    v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                    custom-config
                    type="text-editor"
                    class="shadow-sm w-100 " 
                    :required="true"
                    :id="'text-editor-id' + index + val_index"
                    :label="custom_value.field_name"
                    :class="{ required: custom_value.required }"
                    :name="custom_value.field_name" 
                    :ref="custom_value.field_name"
                    @input="setCustomValue(
                      getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      ),
                      custom_value
                    )" :value="getFieldOperationValue(
                        operations_values[custom_value.field_key].operand1,
                        operations_values[custom_value.field_key].operand2,
                        operations_values[custom_value.field_key].operator,
                        operations_values[custom_value.field_key].type
                      )"
                    oninput='this.classList.remove("invalid")'
                    :placeholder="custom_value.field_name" 
                  />

                  <app-input v-else
                    custom-config
                    type="text-editor"
                    class="shadow-sm w-100 " 
                    :required="true"
                    :id="'text-editor-id' + index + val_index"
                    :key="'text-editor-id' + index + val_index"
                    :label="custom_value.field_name"
                    :class="{ required: custom_value.required }"
                    :name="custom_value.field_name" 
                    :ref="custom_value.field_name"
                    v-model="field_values[index][val_index].value"
                    @input="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" 
                    oninput='this.classList.remove("invalid")'
                    :placeholder="custom_value.field_name" 
                  />

                  <div class="input-group-append tooltip-container">
                    <button type="button" class="btn btn-outline-info border-0 tooltip-button" 
                      @mouseenter="showTooltip($event, custom_value.field_key)"
                      @mouseleave="hideTooltip()"
                      @click="toggleTooltip($event, custom_value.field_key)">
                      <i class="fas fa-info-circle"></i>
                    </button>
                    <div :class="['custom-tooltip', { 'show': isTooltipActive(custom_value.field_key) }]">
                      <p v-html="custom_value.description || 'No description available'"></p>
                    </div>
                  </div>
                </div>
              </div>

              <!--radio-->
              <div v-if="'radio' === custom_value_type(custom_value.custom_field_type_id)">
                <label for="" class="m-0 d-block">{{ custom_value.field_name }}</label>
                <div class="form-check form-check-inline" v-for='(item, item_index) in (custom_value.choices.split(";"))' :key="item_index">
                  <input class="form-check-input" oninput='this.classList.remove("invalid")'
                    :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                    :name="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" type="radio" :id="'inlineRadio' + item_index" :value="item">
                  <label class="form-check-label" :for="'inlineRadio' + item_index"> {{ item }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="right"
                    :title="custom_value.description ?? custom_value.field_name">
                    <i class="fas fa-info-circle" style="font-size: 20px"></i>
                  </button>
                </div>
              </div>

              <!--checkbox-->
              <div v-if="'checkbox' === custom_value_type(custom_value.custom_field_type_id)">
                <label for="" class="m-0 d-block">{{ custom_value.field_name }}</label>
                <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#single:')">
                  <input class="form-check-input" id="checkbox-1" oninput='this.classList.remove("invalid")'
                    :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                    v-model="field_values[index][val_index].value" @change="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" :value="custom_value.choices
                      .replace(/#multiple:|#single:/gi, '')
                      .split(';')[0]
                    " :unchecked-value="custom_value.choices
                      .replace(/#multiple:|#single:/gi, '')
                      .split(';')[1]
                    " type="checkbox">
                  <label class="form-check-label" for="inlineCheckbox1">{{ custom_value.field_name }}</label>
                </div>

                <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#multiple:')"
                  v-for='(item, item_index) in custom_value.choices.replace(/#multiple:|#single:/gi, "").split(";")' :key="item">
                  <input class="form-check-input" :id="item" :class="{ required: custom_value.required }"
                   :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                      field_values[index][val_index].value,
                      custom_value
                    )" oninput='this.classList.remove("invalid")' type="checkbox" :value="item">
                  <label class="form-check-label" :for="item">{{ item }}</label>
                </div>

                <div class="form-check form-check-inline">
                  <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="right"
                    :title="custom_value.description ?? custom_value.field_name">
                    <i class="fas fa-info-circle" style="font-size: 20px"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>

          <div class="buttons">
            <button
              type="button"
              class="previous_button bg-outline-secondary"
              :disabled="preloader || filePreloader"
              @click="nextPrev(-1)"
              v-if="formnumber > 0"
            >
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
              Previous
            </button>
            <button
              type="button"
              class="next_button bg-success text-light"
              :disabled="preloader || filePreloader"
              @click="nextPrev(1)"
              v-if="formnumber < pages.length - 1"
            >
              Next
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="next_button bg-success text-light"
              :disabled="preloader || filePreloader"
              @click="nextPrev(1)"
              v-if="formnumber === pages.length - 1"
            >
              Save
              <i class="fa fa-check-circle" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <!-- Success page after completion -->
        <div class="main" v-if="formnumber >= pages.length" :class="formnumber >= pages.length ? 'active' : ''">
          <div class="success-content">
            <div class="top-div text-center">
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
              <h2 style="color: #10b981; font-size: 32px; margin-bottom: 16px;">Success!</h2>
              <p style="color: #6b7280; font-size: 18px; margin-bottom: 32px;">
                Your form has been submitted successfully
              </p>
            </div>
            <div class="check_box" style="background: #f0fdf4; padding: 24px; border-radius: 12px; border: 2px solid #10b981; margin-bottom: 32px;">
              <p style="color: #047857; font-weight: 600; margin: 0;">
                <i class="fas fa-check-circle" style="margin-right: 8px;"></i>
                All your information has been saved successfully
              </p>
            </div>
            <div class="buttons">
              <button
                type="submit"
                class="next_button bg-success text-light"
                style="width: 200px;"
              >
                <i class="fas fa-arrow-right" style="margin-right: 8px;"></i>
                Continue
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
  <div v-else class="w-100 text-center mt-4 pt-4">
    <h3 class="text-center text-warning mt-4 pt-4">
      You need to add pages and customs values on your application.
    </h3>
    <a :href="urlGenerator('app/custom')" type="button" class="btn btn-primary btn-with-shadow mt-4">
      custom values
    </a>
  </div>
</template>

<script>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Verte from 'verte';
import coreLibrary from "../../../../core/helpers/CoreLibrary";
import 'verte/dist/verte.css';
import Multiselect from "vue-multiselect";
import FirstInput from "./components/FirstInput.vue";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";

import File from "./components/file.vue";
export default {
  mixins: [FormMixin],
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "customization",
    "originalCustomValues",
    "formname",
    "emptyStateConfig",
  ],
  components: { Multiselect, verte: Verte, FirstInput, File },

  data() {
    return {
      modalName: "",
      modalDescription: "",
      name: "TextArea",
      next_click: [],
      main_form: [],
      step_list: [],
      num: [],
      formnumber: 0,
      validate_inputs: [],
      validate_textarea: [],
      nb: 5,



      urlGenerator,
      preloader: false,
      filePreloader: false,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      customValues: [],
      activeTooltipId: null,
      tooltipTimeout: null,

      fieldValueMap: new Map(),
      testFieldValueMap: new Map()

    };
  },


  computed: {
    progressPercentage() {
      if (this.pages.length === 0) return 0;
      return ((this.formnumber + 1) / this.pages.length) * 100;
    },
    progressWidth() {
      if (this.pages.length <= 1) return '0%';
      const width = (this.formnumber / (this.pages.length - 1)) * 80;
      return `${width}%`;
    }
  },

  created() {
    this.reorderPage();

    this.pages.forEach((page, page_index) => {
      let data = [];
      //page.custom_values.sort(this.compare);
      Object.values(page.custom_values).forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value ?? "") });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {

                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {

                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {

                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });
      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });

    this.buildFieldValueMaps();
  },

  mounted() {
    this.next_click = document.querySelectorAll(".next_button");
    this.main_form = document.querySelectorAll(".main");
    this.step_list = document.querySelectorAll(".progress_bar li");
    this.num = document.querySelector(".step-number");
    this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active textarea")];

    this.next_click.forEach((next_click_form, index) => {
      if (index == 0) {
        next_click_form.addEventListener("click", () => {
          this.save(true);
        });
      } else {
        next_click_form.addEventListener("click", () => {
          this.save(false);
        });
      }
    });
    var back_click = document.querySelectorAll(".back_button");
    back_click.forEach((back_click_form) => {
      back_click_form.addEventListener("click", this.onBack);
    });
    var username = document.querySelector("#user_name");
    var shownname = document.querySelector(".shown_name");
    var submit_click = document.querySelectorAll(".submit_button");
    submit_click.forEach(function (submit_click_form) {
      submit_click_form.addEventListener("click", function () {
        shownname.innerHTML = username.value;
        this.formnumber++;
        this.updateform();
      });
    });
    
    // Add click outside listener for tooltips
    document.addEventListener('click', this.handleClickOutside);
  },
  
  beforeDestroy() {
    // Clean up event listener
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    replaceFieldKeysWithValues(text) {
      if (!text || typeof text !== 'string') return text;
      
      const valueMap = this.action === "test" ? this.testFieldValueMap : this.fieldValueMap;
      
      const pattern = new RegExp(
        Array.from(valueMap.keys())
          .map(key => this.escapeRegExp(key))
          .join('|'),
        'g'
      );

      return text.replace(pattern, match => valueMap.get(match) || '');
    },
    escapeRegExp(string) {
        if (!string) return '';
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    getPrefixValue(prefix){
      if (prefix && prefix.length > 0) {
        return prefix
      } else {
        return ""
      }
    },

    getSuffixValue(suffix){
      if (suffix && suffix.length > 0) {
        return suffix
      } else {
        return ""
      }
    },

    removePrefixSuffixValue(prefix, suffix, value) {
      if (typeof value !== "string") {
        return value
      }
      if (value.startsWith(prefix) && prefix!=null) {
        value = value.substr(prefix.length);
      }

      if (value.endsWith(suffix) && suffix!=null) {
        value = value.substr(0, value.length - suffix.length);
      }
      return value;
    },

    hasOperation(fieldKey, field_key){
      return this.operations_index.includes(fieldKey) || this.operations_index.includes(field_key);
    },

    buildFieldValueMaps() {
      this.fieldValueMap.clear();
      this.testFieldValueMap.clear();

      if (!this.originalCustomValues) return;

      if (Array.isArray(this.originalCustomValues)) {
        this.originalCustomValues.forEach(field => {
          this.testFieldValueMap.set(field.fieldKey, field.value || '');
        });
      } else if (this.originalCustomValues.customValues) {
        this.originalCustomValues.customValues.forEach(field => {
          this.fieldValueMap.set(field.fieldKey, field.value || '');
        });
      }
    },

    showToolTip(_child) {
      let explanations = document.querySelectorAll(".SpeechBubble");

      let child = document.querySelector(_child);
      var scaleX = child.getBoundingClientRect().width / child.offsetWidth;
      if (scaleX == 0) {
        explanations.forEach(element => {
          element.style.animationName = "shrink";
          element.style.animationDuration = "0.1s";
        });

        child.style.animationName = "expand-bounce";
        child.style.animationDuration = "0.25s";
      } else {
        child.style.animationName = "shrink";
        child.style.animationDuration = "0.1s";
      }
    },

    hideToolTip(_child) {
      let child = document.querySelector(_child);
      child.style.animationName = "shrink";
      child.style.animationDuration = "0.1s";
    },

    ShowToolTip(name, description) {
      this.modalName = name;
      this.modalDescription = description;
      window.dialog.showModal();
    },

    HideToolTip() {
      this.modalName = "";
      this.modalDescription = "";
      window.dialog.close();
    },

    reorderPage() {
      this.pages.sort((a, b) => {
        if (a.position < b.position) {
          return -1;
        }
        if (a.position > b.position) {
          return 1;
        }

        return 0;
      });
    },

    showTab(index) {
      // Allow navigation to any step
      this.formnumber = index;
      this.updateform();
    },

    nextPrev(n, save = false) {
      // Handle Previous button
      if (n === -1 && this.formnumber > 0) {
        this.formnumber = this.formnumber - 1;
        this.updateform();
        return;
      }
      
      // Handle Next button
      if (n === 1) {
        // Exit if any field in the current tab is invalid:
        if (!this.validateForm()) return false;
        
        // Reset customValues on first tab
        if (this.formnumber == 0) this.customValues = [];
        
        // Collect values from current tab
        Object.values(this.pages[this.formnumber].custom_values).forEach(
          (custom_value) => {
            const operation = this.operations.find(
              ({ result }) => result === custom_value.fieldKey
            );

            if (operation == null) {
              this.customValues.push({
                id: custom_value.id,
                name: custom_value.name,
                value:
                  typeof custom_value.value == "object"
                    ? custom_value.value.join(";")
                    : custom_value.value,
              });
            } else {
              this.customValues.push({
                id: operation.result,
                name: this.getOperationName(operation.result),
                value: this.getOperationValue(operation),
              });
            }
          }
        );

        // Check if we're on the last tab
        if (this.formnumber >= this.pages.length - 1) {
          // Handle final submission
          this.operations.forEach((operation) => {
            const result = this.customValues.find(
              ({ id }) => id === operation.result
            );
            if (result == null) {
              this.customValues.push({
                id: this.getOperationId(operation.result),
                name: this.getOperationName(operation.result),
                value: this.getOperationValue(operation),
              });
            }
          });
          
          this.$emit("save", this.action, this.customValues, this.formnumber, n, true);
          // Show success page
          // this.formnumber = this.formnumber + 1;
          // this.updateform();
          return false;
        } else {
          // Move to next tab
          if (this.pages.length < 2) {
            // Handle single page form
            this.operations.forEach((operation) => {
              const result = this.customValues.find(
                ({ id }) => id === operation.result
              );
              if (result == null) {
                this.customValues.push({
                  id: this.getOperationId(operation.result),
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }
            });
          }
          
          this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, save);
          
          // Update formnumber and show the next tab
          // this.formnumber = this.formnumber + 1;
          // this.updateform();
        }
      }
    },

    validateForm() {
      // This deals with validation of the form fields
      var x,
        y,
        i,
        valid = true;
      x = document.getElementsByClassName("main");
      y = x[this.formnumber].getElementsByClassName("required");

      // A loop that checks every input field in the current tab:
      for (i = 0; i < y.length; i++) {
        // If a field is empty...
        if (y[i].value == "") {
          // add an "invalid" class to the field:
          y[i].classList.add("invalid");
          // and set the current valid status to false:
          valid = false;
        }
      }

      return valid; // return the valid status
    },

    contentChange(change = false) {
      this.customValues = [];

      Object.values(this.pages[this.formnumber].custom_values).forEach(
        (custom_value, val_index) => {
          const operation = this.operations.find(
            ({ result }) => result === custom_value.fieldKey
          );

          if (operation == null) {
            this.customValues.push({
              id: custom_value.cv_id,
              fieldKey: custom_value.fieldKey,
              field_type: this.custom_value_type(custom_value.custom_field_type_id),
              name: custom_value.name,
              value:
                (typeof custom_value.value == "object"
                  ? this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.join(";"))
                  : this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value.split('\n').join(' ')))+this.getSuffixValue(custom_value.suffix),
            });
          } else {
            this.customValues.push({
              id: custom_value.cv_id,
              fieldKey: custom_value.fieldKey,
              field_type: this.custom_value_type(custom_value.custom_field_type_id),
              name: custom_value.name,
              value: this.getPrefixValue(custom_value.prefix)+this.getOperationValue(operation)+this.getSuffixValue(custom_value.suffix),
            });
          }
        }
      );

      if (this.formnumber == this.pages.length - 1) {
        let customs = [];
        this.pages.forEach((page) => {
          customs.push(...Object.values(page.custom_values));
        });

        this.operations.forEach((operation) => {
          const result = customs.find(
            ({ fieldKey }) => fieldKey === operation.result
          );

          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              fieldKey: operation.result,
              field_type: '',
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }

        });


        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber, true);
        return false;
      }

      if (change) {
        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, change);
      } else {
        this.$emit("save", this.action, this.customValues, this.formnumber, this.formnumber + 1, false);
      }
    },

    save(change) {
      if (!this.validateform()) {
        return false;
      }
      this.contentChange(change);
    },

    onNext() {
      this.formnumber++;
      this.updateform();
      this.progress_forward();
    },
    onBack() {
      this.formnumber--;
      this.updateform();
      this.progress_backward();
    },
    updateform() {
      this.main_form.forEach(function (mainform_number) {
        mainform_number.classList.remove("active");
        mainform_number.classList.remove("slideDown");
      });
      this.main_form[this.formnumber].classList.add("slideDown");
      this.main_form[this.formnumber].classList.add("active");
    },
    progress_forward() {
      this.num.innerHTML = this.formnumber + 1;
      this.step_list[this.formnumber].classList.add("active");
    },
    progress_backward() {
      var form_num = this.formnumber + 1;
      this.step_list[form_num].classList.remove("active");
      this.num.innerHTML = form_num;
    },
    validateform() {
      let validate = true;
      this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active select"), ...document.querySelectorAll(".main.active textarea")];
      this.validate_inputs.forEach(function (validate_input) {
        validate_input.classList?.remove("warning");
        if (validate_input.classList.value?.includes("require")) {
          if (validate_input.value.length == 0) {
            validate = false;
            validate_input.classList?.add("warning");
          }
        }
      });
      return validate;
    },


    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    saveFile(file, custom) {

      this.filePreloader = true
      let data = new FormData();
      data.append("file", file);
      data.append("custom_id", custom.id);
      coreLibrary.methods.axiosPost({
        url: "/file/upload",
        data,
      }).then(({ data }) => {
        custom.value = data
        custom.hhh = data
      })
        .catch(({ response }) => {
          if (response.data && response.data.message) {
            this.$toastr.e(response.data.message);
            const errors = Object.values(response.data.data).map((el) => el[0]);
            this.$toastr.e(errors);
          }
        })
        .finally(() => {
          this.filePreloader = false

        });
    },

    reoderCustomValues(customValues) { },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },

    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = this.removePrefixSuffixValue(custom.prefix, custom.suffix, value);
      }
    },

    getFieldOperationValue(operand1, operand2, operator, type) {
      let op2;
      let op1;

      var operand1_without_space = operand1.replace(/\s+/g, "");
      var operand2_without_space = operand2.replace(/\s+/g, "");

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } 
      else if (this.field_index[operand1_without_space] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1_without_space]][
            this.field_index[operand1_without_space]
          ].value;
      }
      else {
        op1 = this.findOperationValue(operand1);
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } 
      else if (this.field_index[operand2_without_space] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2_without_space]][
            this.field_index[operand2_without_space]
          ].value;
      } 
      else {
        op2 = this.findOperationValue(operand2);
      }

      return this.makeOperation(type, operator, op1, op2);
    },

    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseFloat(op1);
        op2 = parseFloat(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },

    next(tab, n) {
      this.showTab(n);
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },

    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },

    findOperationValue(op) {
      if (this.field_index[op] !== undefined) {
        let op1 =
          this.field_values[this.page_index[op]][
            this.field_index[op]
          ].value;
          return op1;
      }

      let value;
      const result = Object.values(this.pages[this.formnumber].custom_values).find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value??'';
        }
      } else {
        value = result.value??'';
      }
      return value;
    },

    showTooltip(event, fieldKey) {
      clearTimeout(this.tooltipTimeout);
      this.activeTooltipId = fieldKey;
      console.log('Showing tooltip for:', fieldKey);
    },

    hideTooltip() {
      this.tooltipTimeout = setTimeout(() => {
        this.activeTooltipId = null;
        console.log('Hiding tooltip');
      }, 300);
    },

    toggleTooltip(event, fieldKey) {
      event.stopPropagation();
      
      if (this.activeTooltipId === fieldKey) {
        this.activeTooltipId = null;
        console.log('Toggling tooltip OFF for:', fieldKey);
      } else {
        clearTimeout(this.tooltipTimeout);
        this.activeTooltipId = fieldKey;
        console.log('Toggling tooltip ON for:', fieldKey);
      }
    },
    
    handleClickOutside(event) {
      if (!event.target.closest('.tooltip-button')) {
        this.activeTooltipId = null;
        console.log('Hiding tooltip - clicked outside');
      }
    },
    
    isTooltipActive(fieldKey) {
      const isActive = this.activeTooltipId === fieldKey;
      if (isActive) {
        console.log('Tooltip is active for:', fieldKey);
      }
      return isActive;
    },

  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tags {
  background-color: transparent !important;
  min-height: 42px !important;
  padding: 12px 40px 0 5px !important;
  outline: 0 !important;
  border: 1px solid #d4dfe4 !important;
  border-right: none !important;
  border-radius: 0px !important;
}
.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background-color: blue !important;
  color: white !important;
}
.multiselect__select {
  padding: 30px 8px;
}
</style>
